namespace TabAurous.Sales {
    export interface MaterialOutForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        GstVat: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: MaterialOutItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class MaterialOutForm extends Serenity.PrefixedContext {
        static formKey = 'Sales.MaterialOut';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialOutForm.init)  {
                MaterialOutForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = s.TextAreaEditor;
                var w7 = s.DecimalEditor;
                var w8 = MaterialOutItemsEditor;

                Q.initFormType(MaterialOutForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'PartyId', w5,
                    'LedgerName', w2,
                    'Address1', w6,
                    'State', w2,
                    'Country', w2,
                    'TermsId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'CurrencyId', w5,
                    'ExchRate', w7,
                    'GstVat', w2,
                    'UserId', w5,
                    'EmployeeId', w3,
                    'ItemDetails', w8,
                    'FinancialYearId', w3,
                    'NetAmount', w7,
                    'TaxAmount', w7,
                    'Discount', w7,
                    'AdditionalCharges', w7,
                    'GrossAmount', w7,
                    'Pieces', w3,
                    'Weight', w7,
                    'NetWeight', w7,
                    'Remark', w6,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
